import React from 'react';
import { Provider } from 'react-redux';

import store from 'client/redux/store';

import useListenSmallScreen from 'client/hooks/useListenSmallScreen';
import useSpecificIframeEmbedInitPostMsg from 'client/hooks/useSpecificIframeEmbedInitPostMsg';

import DialogSystemError from 'client/components/DialogSystemError';
import ProviderFlowInfoAndActionChecker from 'client/components/infoDialog/ProviderFlowInfoAndActionChecker';
import ErrorBoundaryApp from 'client/components/ErrorBoundaryApp';
import ProviderMuiPickersUtils from 'components/ProviderMuiPickersUtils';

export default function GeneralClientFlowWrapper({ children }) {
    return (
        <ErrorBoundaryApp>
            <Provider store={store}>
                <ProviderMuiPickersUtils>
                    <ProviderFlowInfoAndActionChecker>
                        <DialogSystemError />
                        <EffectWrapper>{children}</EffectWrapper>
                    </ProviderFlowInfoAndActionChecker>
                </ProviderMuiPickersUtils>
            </Provider>
        </ErrorBoundaryApp>
    );
}

function EffectWrapper({ children }) {
    useListenSmallScreen();
    useSpecificIframeEmbedInitPostMsg('widget');
    useSpecificIframeEmbedInitPostMsg('zines');
    return children;
}
